import React from "react";
import Page from "../components/Page";
const ContactPage = () => {
  return <Page>Contact</Page>;
};

export default ContactPage;
